<div class="message message-out">
  <div class="message-inner message-inner_noavatar">
    <div class="message-body">
      <div class="message-content">
        <div class="message-text p-4 p-md-8 d-flex flex-column align-content-lg-stretch pulse bg-secsel">
          <button
            type="button"
            (click)="askQuestion()"
            class="btn btn-outline app-btn-white mb-3">
            Ask a question about your task
          </button>
          <span class="attach-divider text-center my-4">
            or
          </span>
          <button
            type="button"
            (click)="markAsDone()"
            class="btn btn-outline app-btn-yellow">
            Mark as done
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
